import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FrontPageGuard } from './_shared';

import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { MaintenanceModeComponent } from './maintenance-mode/maintenance-mode.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ExpiredLinkComponent } from './expired-link/expired-link.component';

const routes: Routes = [
  // public routes
  {
    path: '',
    component: LoginComponent,
    canActivate: [FrontPageGuard],
    pathMatch: 'full',
    data: { title: 'Login' }
  },
  {
    path: 'forgotpassword',
    component: ForgotPasswordComponent,
    canActivate: [FrontPageGuard],
    data: { title: 'Forgot Password' }
  },
  {
    path: 'reset/:token',
    component: ResetPasswordComponent,
    canActivate: [FrontPageGuard],
    data: { title: 'Reset Password' }
  },
  {
    path: 'expired',
    component: ExpiredLinkComponent,
    canActivate: [FrontPageGuard],
    data: { title: 'Expired Link' }
  },
  {
    path: 'maintenance',
    component: MaintenanceModeComponent,
    data: { title: 'Under Maintenance' }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/app-routing.module.ts